const degreesToRadians = (degrees: number): number => (degrees * Math.PI) / 180;

export { degreesToRadians };
